import { Router } from '../../configs/routes';
import ScheduleMandate from '../../components/paymentSchedule/scheduleMandate';
import ScheduleMethodModal from '../../components/paymentSchedule/scheduleMethodModal';

const dismissScheduleModal = ({ query }) => {
  const { schedulePayment, paymentMode, ...queryObj } = query;
  Router.pushRoute(`${location.pathname}`, queryObj);
};

const dismissMandateModal = ({ query }) => {
  const {
    mandateModal,
    sipDate,
    firstPaymentDate,
    schedulePayment,
    paymentMode,
    ...queryObj
  } = query;
  Router.pushRoute(`${location.pathname}`, queryObj);
};

const MandateFlowView = props => {
  const { investmentType, amount, url } = props;
  const schedulePayment = url.query.schedulePayment;
  return (
    <div>
      {/* shows modal to select mandate or payment link option */}
      {schedulePayment === 'methodSelect' ? (
        <ScheduleMethodModal
          dismissModal={() => dismissScheduleModal(url)}
          investmentType={investmentType}
          url={url}
        />
      ) : null}
      {/* this renders modal to go through mandate procedure */}
      {/* this also handles payment link setup */}
      {schedulePayment === 'sipPayment' ||
      schedulePayment === 'lumpsumPayment' ? (
        <ScheduleMandate
          dismiss={() => dismissMandateModal(url)}
          url={url}
          investmentType={investmentType}
          amount={amount}
        />
      ) : null}
    </div>
  );
};

export default MandateFlowView;



// WEBPACK FOOTER //
// ./components/mandate/mandateFlowView.tsx